import { supabase } from '@/lib/supabase/client';

/**
 * Utility function to debug job card queries with better logging
 * This can be used to troubleshoot job card data access issues
 */
export const debugJobCardFetch = async (id: string) => {
  console.log(`[JobCardDebugger] Attempting to fetch job card with ID: ${id}`);
  
  try {
    // First attempt direct query to job_cards_with_details
    console.log('[JobCardDebugger] Attempting direct view query...');
    const { data: viewData, error: viewError } = await supabase
      .from('job_cards_with_details')
      .select('*')
      .eq('id', id)
      .single();
    
    if (viewError) {
      console.error('[JobCardDebugger] View query error:', viewError);
    } else {
      console.log('[JobCardDebugger] View query successful:', !!viewData);
    }
    
    // Second attempt using RPC function
    console.log('[JobCardDebugger] Attempting RPC function query...');
    const { data: rpcData, error: rpcError } = await supabase
      .rpc('get_job_card_by_id', { job_card_id: id });
    
    if (rpcError) {
      console.error('[JobCardDebugger] RPC query error:', rpcError);
    } else {
      console.log('[JobCardDebugger] RPC query successful:', rpcData.length > 0);
    }
    
    // Return the results for comparison
    return {
      viewResult: { data: viewData, error: viewError },
      rpcResult: { data: rpcData, error: rpcError }
    };
  } catch (error) {
    console.error('[JobCardDebugger] Unexpected error during debug:', error);
    return {
      viewResult: { data: null, error },
      rpcResult: { data: null, error }
    };
  }
};

/**
 * Use this to check access permissions for the current user
 */
export const checkJobCardAccess = async () => {
  console.log('[JobCardDebugger] Checking user permissions for job card access');
  
  try {
    // Verify user authentication 
    const { data: user } = await supabase.auth.getUser();
    console.log('[JobCardDebugger] Current user:', user?.user?.id);
    
    // Test job_cards table access
    console.log('[JobCardDebugger] Testing job_cards table access...');
    const { data: jobCardsData, error: jobCardsError } = await supabase
      .from('job_cards')
      .select('id')
      .limit(1);
    
    console.log('[JobCardDebugger] job_cards access:', !jobCardsError, jobCardsData?.length);
    
    // Test job_cards_with_details view access
    console.log('[JobCardDebugger] Testing job_cards_with_details view access...');
    const { data: viewData, error: viewError } = await supabase
      .from('job_cards_with_details')
      .select('id')
      .limit(1);
    
    console.log('[JobCardDebugger] view access:', !viewError, viewData?.length);
    
    return {
      authenticated: !!user?.user,
      jobCardsAccess: { success: !jobCardsError, data: jobCardsData },
      viewAccess: { success: !viewError, data: viewData }
    };
  } catch (error) {
    console.error('[JobCardDebugger] Unexpected error during access check:', error);
    return {
      authenticated: false,
      jobCardsAccess: { success: false, error },
      viewAccess: { success: false, error }
    };
  }
};
